const usd = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2 });
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const MONTHS_LONG = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export const AMOUNT_ERROR = "Enter an amount greater than 0";
export const DATE_ERROR = "Choose a date on or before today";
export const BUDGET_ERROR = "Enter a budget of 0 or more";

export const PAYMENT_METHODS = [
  { value: "cash", label: "Cash" },
  { value: "card", label: "Card" },
  { value: "cheque", label: "Cheque" },
  { value: "bank_transfer", label: "Bank transfer" },
  { value: "other", label: "Other" },
];
export const paymentLabel = (v) => PAYMENT_METHODS.find((p) => p.value === v)?.label || v;

export const money = (cents) => usd.format((cents || 0) / 100);
export const centsToInput = (cents) => (cents == null ? "" : (cents / 100).toFixed(2));

export const todayNassau = () =>
  new Intl.DateTimeFormat("en-CA", { timeZone: "America/Nassau", year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date());

export const formatDate = (iso) => {
  if (!iso) return "";
  const [y, m, d] = iso.split("-").map(Number);
  return `${MONTHS[m - 1]} ${d}, ${y}`;
};

export const monthShort = (ym) => {
  const [y, m] = ym.split("-").map(Number);
  return `${MONTHS[m - 1]} ${String(y).slice(2)}`;
};

export const monthLong = (ym) => {
  const [y, m] = ym.split("-").map(Number);
  return `${MONTHS_LONG[m - 1]} ${y}`;
};

export function isValidAmount(value) {
  const text = String(value ?? "").trim().replace(/[,$]/g, "");
  if (!/^\d+(\.\d{1,2})?$|^\.\d{1,2}$/.test(text)) return false;
  return Number(text) > 0;
}

export function isValidBudget(value) {
  const text = String(value ?? "").trim().replace(/[,$]/g, "");
  if (text === "") return true;
  return /^\d+(\.\d{1,2})?$/.test(text);
}
